



















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  name: 'TableMenu',
  data() {
    return {
      titleUserActive: 'Total Category Visited',
      titleCategoryMaterials: 'Total Material Type Visited',
      alignCard: 'center',
      fieldsUserActive: [
        { key: 'no' },
        { key: 'title' },
        { key: 'total_user' },
        { key: 'total_visit' },
      ],
      fieldsCategoryMaterials: [
        { key: 'no' },
        { key: 'type_name' },
        { key: 'total_user' },
        { key: 'total_visit' },
      ],
      top_visit_by_type: [
        {
          type_name: 'video',
          total_visit: 70,
        },
        {
          type_name: 'docs',
          total_visit: 60,
        },
      ],
    }
  },
})
export default class extends Vue {
  @Prop({}) public dataTable
  @Prop({}) public dataTableType
}
